import useStateStore from 'services/store';
import './fit.scss';
import FormInput from 'components/FormInput/FormInput';

const fitSize = [
  {
    id: 'tight',
    name: 'tight',
    image: 'images/infor/shirt-fit-tight.svg',
    description: 'Tight',
  },
  {
    id: 'fitted',
    name: 'fitted',
    image: 'images/infor/shirt-fit-fitted.svg',
    description: 'Fitted',
  },
  {
    id: 'relaxed',
    name: 'relaxed',
    image: 'images/infor/shirt-fit-relaxed.svg',
    description: 'Relaxed',
  },
  {
    id: 'very-relaxed',
    name: 'very-relaxed',
    image: 'images/infor/shirt-fit-very-relaxed.svg',
    description: 'Very relaxed',
  },
];


const commonForm = [
  {
    id: 'chest',
    name: 'chest',
    placeHolder: 'Chest',
  },
  {
    id: 'stomach',
    name: 'stomach',
    placeHolder: 'Stomach',
  },
  {
    id: 'hips',
    name: 'hips',
    placeHolder: 'Hips',
  },
];

const finishedForm = [
  {
    id: 'shoulder',
    name: 'shoulder',
    placeHolder: 'Shoulder',
  },
  {
    id: 'sleeves-long',
    name: 'sleeves-long',
    placeHolder: 'Sleeves Long',
  },
  {
    id: 'sleeves-short',
    name: 'sleeves-short',
    placeHolder: 'Sleeves Short',
  },
  {
    id: 'biceps',
    name: 'biceps',
    placeHolder: 'Biceps',
  },
  {
    id: 'wrist',
    name: 'wrist',
    placeHolder: 'Wrist',
  },
  {
    id: 'front-length',
    name: 'front-length',
    placeHolder: 'Front Length',
  },
];

const Fit = () => {
  const {
    inforStepValues: steps,
    changeInforStepValues,
    changeInforInputValues,
    inforFlow,
    inforInputValues: inputValues,
  } = useStateStore();
  const handleChangeSteps = (id: string) => {
    changeInforStepValues('fit', id);
  };
  return (
    <div className="body-container">
      <div className="infor">
        <div className="title">HOW WOULD YOU LIKE YOUR SHIRT TO FIT?</div>
      </div>
      <div className="image-options">
        {fitSize.map((shape) => (
          <div
            onClick={() => handleChangeSteps(shape.id)}
            key={shape.id}
            className={`img-option ${
              steps['fit'] === shape.id ? 'active' : ''
            }`}
          >
            <div className="img-container">
              <img src={shape.image} alt="" />
            </div>
            <div className="text">{shape.description}</div>
          </div>
        ))}
      </div>
      <form className="personal-detail-form">
        {inforFlow === 'body' && (
          <FormInput
            onChange={(e) => changeInforInputValues('neck', e.target.value)}
            label="NECK"
            id="neck"
            name="neck"
            placeholder="Neck"
            value={inputValues?.neck}
          />
        )}
        {commonForm.map((form) => (
          <FormInput
            key={form.id}
            label={form.name.toUpperCase()}
            id={form.id}
            name={form.name}
            placeholder={form.placeHolder}
            value={inputValues?.[form.id]}
            onChange={(e) => changeInforInputValues(form.id, e.target.value)}
          />
        ))}
        {inforFlow === 'finished' && (
          <>
            {finishedForm.map((form) => (
              <FormInput
                onChange={(e) =>
                  changeInforInputValues(form.id, e.target.value)
                }
                key={form.id}
                label={form.name.toUpperCase()}
                id={form.id}
                name={form.name}
                placeholder={form.placeHolder}
                value={inputValues?.[form.id]}
              />
            ))}
          </>
        )}
      </form>
    </div>
  );
};

export default Fit;
